import { render, staticRenderFns } from "./LiberacaoFerias.vue?vue&type=template&id=7b38a35d&scoped=true&"
import script from "./LiberacaoFerias.vue?vue&type=script&lang=js&"
export * from "./LiberacaoFerias.vue?vue&type=script&lang=js&"
import style0 from "./LiberacaoFerias.vue?vue&type=style&index=0&id=7b38a35d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b38a35d",
  null
  
)

export default component.exports